export default "__VITE_PUBLIC_ASSET__049997cc__"